import { Injectable } from '@angular/core';
import { ToolingTaskApi } from 'src/api';
import { ToolingTaskInfo } from 'src/api/tooling-task.api';
import { TaskBaseService } from './task-base.service';

@Injectable()
export class ToolingTaskService extends TaskBaseService<ToolingTaskInfo> {
  constructor(private toolingTaskApi: ToolingTaskApi) {
    super(toolingTaskApi);
  }

  /**
   * Gets all tasks related to a tooling.
   */
  tasksByTooling$(toolingId: string) {
    return this.toolingTaskApi.tasksByTooling$(toolingId);
  }
}
